import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedModule } from '../../shared.module';

@Component({
  templateUrl: './message-dialog.component.html',
  standalone: false,
  //imports: [SharedModule],
  styles: [],
})
export class MessageDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: MessageParams) {}

  get message(): string {
    return this.data?.message;
  }
}

export type MessageParams = {
  message: string;
};
